import * as yup from "yup";
export const createTripVideoSchema = (v, t) => {
  return yup.object().shape({
    tripVideos: yup.array().min(1, t("thisFieldIsRequired")),
  });
};